import React from "react";
import classNames from "classnames";
import withStyles from "react-jss";

const styles = (theme) => ({
	root: {
		"font-family": theme.fonts.medium,
		textAlign: "center",
	},
	bold: {
		fontFamily: theme.fonts.bold,
	},
	header: {
		"font-size": "24px",
		"line-height": "0.78",
		color: theme.palette.colors.darkSlateBlue,
		"margin-bottom": "10px",
	},
	onlyXs: {
		display: "none",
	},
	headerIsBig: {
		fontSize: "64px",
	},
	headerIsGreen: {
		color: "#24ba8e",
	},
	headerIsPurple: {
		color: theme.palette.colors.purplishBlue,
		cursor: "pointer",
	},
	subheader: {
		"font-size": "14px",
		"line-height": "0.71",
		"letter-spacing": "2px",
		"font-family": `MuseoSansCyrl-500`,
		color: theme.palette.colors.oneMoreGrey,
		"text-transform": "uppercase",
	},
	subheaderIsGreen: {
		color: "#24ba8e",
	},
	noPointer: {
		cursor: "default !important",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		root: {
			textAlign: "center",
			"font-family": `MuseoSansCyrl-700`,
		},
		onlyXs: {
			display: "inline-block",
		},
		header: {
			"font-size": "18px",
		},
		subheader: {
			fontSize: "12px",
			lineHeight: "0.83",
			verticalAlign: "bottom",
		},
	},
});

const Component = ({
	classes,
	value,
	measure,
	bold,
	green,
	big,
	onlyXs,
	purple,
	onClickHandler,
	noPointer,
}) => {
	return (
		<div
			className={classNames(classes.root, {
				[classes.bold]: bold,
				[classes.onlyXs]: onlyXs,
			})}
		>
			<div
				onClick={!!onClickHandler ? onClickHandler : null}
				className={classNames(classes.header, {
					[classes.headerIsGreen]: green,
					[classes.headerIsBig]: big,
					[classes.headerIsPurple]: purple,
					[classes.noPointer]: noPointer,
				})}
			>
				{value}
			</div>
			<div
				className={classNames(classes.subheader, {
					[classes.subheaderIsGreen]: green,
				})}
			>
				{measure}
			</div>
		</div>
	);
};

const Measurements = withStyles(styles)(Component);
Measurements.displayName = "Measurements";

export default Measurements;
